module.exports = require('./helpers/bundle-url').getBundleURL('gK5mg') + "request-callback.8cfeb718.svg";